import { Injectable } from "@angular/core"
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
} from "@angular/router"
import { UserService } from "../services/user.service"

@Injectable()
export class SetTeacherExperienceGuard implements CanActivate {
    constructor(private userService: UserService) {}

    public canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        this.userService.setStudentExperience(false)
        return true
    }
}
